// material-ui
import { List, ListItemText } from '@mui/material'
import { styled } from '@mui/material/styles'
import React from 'react'

import CancelIcon from '@mui/icons-material/Cancel'
import ThumbUpIcon from '@mui/icons-material/ThumbUp'
import {
  Avatar,
  Button,
  Divider,
  Grid,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  Typography,
} from '@mui/material'
import { gridSpacing } from 'store/constant'
import TitleService, { GetTimeSince } from 'title-service'

// assets
import * as autoThunks from 'features/auto-thunks'
import { useEffect } from 'react'

import { getUserClaims } from 'features/application/application-slice'
import { get_all_contentCreatorInvitation } from 'features/contentCreatorInvitation/contentCreatorInvitation-slice'
import {
  get_selected_contentHouse,
  is_contentHouse_busy,
} from 'features/contentHouse/contentHouse-slice'
import { useDispatch, useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

const ListItemWrapper = styled('div')(({ theme }) => ({
  cursor: 'pointer',
  padding: 16,
  '&:hover': {
    background:
      theme.palette.mode === 'dark'
        ? theme.palette.dark.main
        : theme.palette.primary.light,
  },
  '& .MuiListItem-root': {
    padding: 0,
  },
}))
export default function SimpleList() {
  // Generate Grid
  let dispatch = useDispatch()
  let claims = useSelector(getUserClaims)
  let contentCreatorInvitation_list = useSelector(
    get_all_contentCreatorInvitation,
  )
  let contentHouse_busy = useSelector(is_contentHouse_busy)
  let contentHouse = useSelector(get_selected_contentHouse)
  const [visible, setVisible] = React.useState(null)

  useEffect(() => {
    if (claims?.user) {
      dispatch(
        autoThunks.load_my_content_house_invitations({ email: claims?.email }),
      )
    }
  }, [claims?.user])
  useEffect(() => {
    if (claims?.user) {
      function set_visible(): any {
        setVisible(!!contentCreatorInvitation_list?.length)
      }
      set_visible()
    }
  }, [contentCreatorInvitation_list, claims?.user])

  function _(): any {
    return contentHouse
  }

  function ContentHouseTitle(contentHouse: any, reject: any, accept: any): any {
    return (invitation) => {
      if (invitation.deleted) {
        return <></>
      }
      return (
        <>
          <List>
            <ListItemWrapper>
              <ListItem alignItems="center">
                <ListItemAvatar>
                  <Avatar
                    alt={invitation?.contentHouse?.name}
                    src={invitation?.contentHouse?.contentHouseProfileImage}
                  />
                </ListItemAvatar>
                <ListItemText primary={invitation?.contentHouse?.name} />
                <ListItemSecondaryAction>
                  <Grid container justifyContent="flex-end">
                    <Grid item xs={12}>
                      <Typography
                        variant="caption"
                        display="block"
                        gutterBottom
                      >
                        {invitation?.created &&
                          GetTimeSince(invitation?.created)}
                      </Typography>
                    </Grid>
                  </Grid>
                </ListItemSecondaryAction>
              </ListItem>
              <Grid container direction="column" className="list-container">
                <Grid item xs={12} sx={{ pb: 2 }}>
                  <Typography variant="subtitle2">
                    {TitleService('Join our Content House')}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Grid container spacing={gridSpacing}>
                    <Grid item>
                      <Button
                        disabled={contentHouse_busy}
                        onClick={async () => {
                          await dispatch(
                            reject({
                              fire_user: claims.user,
                              invitationId: invitation.id,
                            }),
                          )
                        }}
                        color="secondary"
                        variant="contained"
                        disableElevation
                        endIcon={<CancelIcon stroke={1.5} size="1.3rem" />}
                      >
                        {TitleService('Reject')}
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        disabled={contentHouse_busy}
                        onClick={async () => {
                          await dispatch(
                            accept({
                              fire_user: claims.user,
                              invitationId: invitation.id,
                            }),
                          )
                        }}
                        variant="contained"
                        disableElevation
                        endIcon={<ThumbUpIcon stroke={1.5} size="1.3rem" />}
                      >
                        {TitleService('Accept')}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </ListItemWrapper>
            <Divider />
          </List>
        </>
      )
    }
  }

  let output_ContentHouseTitle = ContentHouseTitle(
    _(),
    autoThunks.reject_invitation,
    autoThunks.accept_invitation,
  )

  function subcard(child: any): any {
    return (
      <>
        {(contentCreatorInvitation_list || []).map((invitation) => {
          return child(invitation)
        })}
      </>
    )
  }

  let output_subcard = subcard(output_ContentHouseTitle)

  function grid(child1: any): any {
    return <>{visible && child1}</>
  }

  let output_grid = grid(output_subcard)

  return output_grid
}
